import React, { useEffect, useState } from "react";
import "react-table/react-table.css";
import MySettings from "../../static/settings";

import { IPageProps } from "../../interfaces/page-props";

import { Button } from "react-bootstrap";
import { Link, RouteComponentProps } from "react-router-dom";
import Loading from "../../components/loading";
import VoipTable from "../../components/VoipTable";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faEdit } from "@fortawesome/free-regular-svg-icons";
import { faWindowClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon as FaIcon } from "@fortawesome/react-fontawesome";
import App from "../../App";
import Error from "../../components/error";
import PageHead from "../../components/PageHead";
import VipBurgerMenu from "../../components/VipBurgerMenu";
import { NOTIFICATION_TYPE } from "../../enum/notification-type";
import { INotification } from "../../interfaces/notification";
import { IPeopleGetHttpResponse, IPerson } from "../../interfaces/people";
library.add(faWindowClose, faEdit);

const set = new MySettings();
interface IResellerPeoplePage extends RouteComponentProps<any>, IPageProps { }

const ResellerPeople: React.FC<IResellerPeoplePage> = (props) => {
  const [resellerPeople, setResellerPeople] = useState<IPerson[]>([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  // console.log("STATE", resellerPeople);

  useEffect(() => {
    let isMounted = true;

    const getResellerPeople = async () => {
      try {
        const resellerPeopleGetResponse: IPeopleGetHttpResponse =
          await set.resellerPeopleGet();
        console.log("DATA", resellerPeopleGetResponse);

        if (isMounted) {
          setResellerPeople(resellerPeopleGetResponse.items);
          setLoading(false);
        }
      } catch (error) {
        console.log(error);

        const notification: INotification = {
          title: "Error",
          data: "API Error Occurred. please retry if problem persists please contact support",
          variant: NOTIFICATION_TYPE.danger,
          srcFunction: "handleNumberDelete",
          srcData: window.location.pathname,
          srcComponent: "People",
        };

        App.newNotification(notification);

        setError(true);

      }
    };

    getResellerPeople();

    return () => {
      isMounted = false;
    };
  }, []);

  const handlePersonDelete = async (id: string) => {
    if (
      window.confirm(
        "Are you sure you want to remove this person?"
      )
    ) {
      try {
        setLoading(true);

        await set.resellerPersonRemove(id);

        setResellerPeople(resellerPeople.filter((person) => person.id !== id));

        const notification: INotification = {
          title: "Success",
          data: "Person removed.",
          variant: NOTIFICATION_TYPE.success,
          srcFunction: "handleNumberDelete",
          srcData: window.location.pathname,
          srcComponent: "PhoneBook",
        };

        App.newNotification(notification);
      } catch (error) {
        console.log(error);
        const notification: INotification = {
          title: "Error",
          data: "Something Went Wrong",
          variant: NOTIFICATION_TYPE.warning,
          srcFunction: "handleNumberDelete",
          srcData: window.location.pathname,
          srcComponent: "PhoneBook",
        };

        App.newNotification(notification);
      }
      setLoading(false);
    }
  };

  const col = [
    {
      Header: "First Name",
      accessor: "firstName",
      sortable: true,
    },
    {
      Header: "Last Name",
      accessor: "lastName",
      sortable: true,
    },
    {
      Header: "Email Address",
      accessor: "emailAddress",
      sortable: true,
    },
    {
      Header: "",
      accessor: "id", // String-based value accessors!
      Cell: (props: any) => {
        const link: string = "./resellerperson/" + props.value;

        return (
          <>
            <Link to={link} className="btn btn-success">
              Edit <FaIcon fixedWidth className="whiteIcon" icon="edit" />
            </Link>
            <Button
              onClick={() => {
                handlePersonDelete(props.value);
              }}
              variant="danger"
            >
              Remove <FaIcon icon="user-minus" color="white" />
            </Button>
          </>
        );
      },
    },
  ];

  return (
    <>
      <div className="content">
        <PageHead resellerID={props.resellerID} title="People" parents={[]}>
          <VipBurgerMenu
            options={[
              {
                title: "New Person",
                link: "./resellerperson/new",
                isExternal: false,
              },
            ]}
          />
        </PageHead>

        {loading ? (
          <Loading />
        ) : error ? (
          <Error />
        ) : (
          <>
            <VoipTable
              title="People"
              data={resellerPeople}
              col={col}
              sortByStart="lastName"
              multiSelect={false}
            />
          </>
        )}
      </div>
    </>
  );
};

export default ResellerPeople;
